<template>
  <div class="site-project-toggle">
    <!-- Toggle Buttons -->
    <div class="toggle-buttons">
      <ThemedButton
        :variant="mode === 'sites' ? 'default' : 'outline'"
        size="sm"
        @click="setMode('sites')"
        class="toggle-button"
      >
        Sites
      </ThemedButton>
      <ThemedButton
        :variant="mode === 'projects' ? 'default' : 'outline'"
        size="sm"
        @click="setMode('projects')"
        class="toggle-button"
      >
        Projects
      </ThemedButton>
    </div>

    <!-- Sites Mode: Show Count -->
    <div v-if="mode === 'sites'" class="site-count">
      {{ visibleSiteCount }} of {{ totalSiteCount }}
    </div>

    <!-- Projects Mode: Show Dropdown -->
    <div v-if="mode === 'projects'" class="project-selector">
      <ThemedSelect
        v-model="selectedProjectId"
        :options="projectOptions"
        :placeholder="loadingProjects ? 'Loading projects...' : `Select a Project (${projects.length} available)`"
        :disabled="loadingProjects"
        @input="onProjectChange"
        class="project-dropdown"
      />
      <span v-if="loadingProjects" class="loading-spinner"></span>
    </div>
  </div>
</template>

<script>
import ThemedButton from '../ThemedButton.vue';
import ThemedSelect from '../ThemedSelect.vue';

export default {
  name: 'SiteProjectToggle',

  components: {
    ThemedButton,
    ThemedSelect
  },

  props: {
    visibleSiteCount: {
      type: Number,
      default: 0
    },
    totalSiteCount: {
      type: Number,
      default: 0
    },
    projects: {
      type: Array,
      default: () => []
    },
    loadingProjects: {
      type: Boolean,
      default: false
    },
    initialMode: {
      type: String,
      default: 'sites',
      validator: (value) => ['sites', 'projects'].includes(value)
    }
  },

  data() {
    return {
      mode: this.initialMode,
      selectedProjectId: null
    };
  },

  mounted() {
    console.log('SiteProjectToggle mounted', {
      visibleSiteCount: this.visibleSiteCount,
      totalSiteCount: this.totalSiteCount,
      projects: this.projects,
      projectsLength: this.projects.length,
      mode: this.mode
    });
  },

  computed: {
    projectOptions() {
      return this.projects.map(project => ({
        label: project.name,
        value: project.id
      }));
    }
  },

  watch: {
    projects: {
      handler(newVal) {
        console.log('SiteProjectToggle - projects prop changed:', newVal, 'length:', newVal.length);
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    setMode(newMode) {
      if (this.mode !== newMode) {
        this.mode = newMode;
        this.selectedProjectId = null;
        this.$emit('mode-changed', newMode);
      }
    },

    onProjectChange() {
      this.$emit('project-selected', this.selectedProjectId);
    }
  }
};
</script>
